import React from 'react';
import Layout from '@/sections/Layout';

import Hero from '@/sections/pages/Features/Hero';
import Media from '@/sections/pages/Features/Media';
import ItemSection from '@/sections/pages/Features/ItemSection';
import Cloud from '@/sections/pages/Features/Cloud';
import RunDevice from '@/sections/pages/Features/RunDevice';
import Registration from 'sections/common/Registration';
import Cases from '@/sections/pages/Features/Cases';

import FeaturesData from '@/mocks/featuresData';

const Features = () => {
  const REGISTRATION_DATA = {
    title: 'test',
    desc: 'test',
    descHighlightedLink: {
      linkText: 'test',
      link: '#',
    },
    formData: {
      btnTxt: '',
      checkboxLabel: 'test',
      checkboxLabelHighlighted: {
        link: '#',
        text: 'test',
      },
      inputs: {},
    },
  };

  return (
    <Layout
      currentPageClass={'cr-features-page'}
      headerClass={'cr-features-header'}
      mainClass={'cr-features-main'}
      footerClass={'cr-features-footer'}
    >
      {(commonData) => (
        <>
          <Hero data={FeaturesData.hero} />
          <Media data={FeaturesData.media} />

          <ItemSection data={FeaturesData.point_of_sale} />
          <ItemSection data={FeaturesData.marketing} className={'cr-reverse'} />

          <Cloud data={FeaturesData.cloud} />
          <ItemSection data={FeaturesData.management} />

          <section className="cr-wrap cr-conv-retail__registr">
            <RunDevice data={FeaturesData.run_device} />
          </section>

          <section className="cr-wrap cr-conv-retail__registr">
            <Registration data={REGISTRATION_DATA} />
          </section>
          <Cases data={FeaturesData.cases} />
        </>
      )}
    </Layout>
  );
};

export default Features;
